import CloseIcon from '@mui/icons-material/Close';
import { Drawer, Box, IconButton, Typography } from '@mui/material';

const SmoothDrawerContainer = ({ open, onClose, children }) => {
	return (
		<Drawer
			open={open}
			anchor="right"
			onClose={onClose}
			ModalProps={{
				keepMounted: true,
			}}
			PaperProps={{
				sx: {
					width: 360,
					overflow: 'hidden',
					background: '#fff',
					borderRadius: '0 0 0 0',
					animation: open ? 'smoothSlideIn 0.35s ease-out' : 'smoothSlideOut 0.25s ease-in',
				},
			}}
			sx={{
				'& .MuiBackdrop-root': {
					backdropFilter: 'blur(3px)',
				},
			}}
		>
			<Box sx={{ p: 2, display: 'flex', alignItems: 'center' }}>
				<Typography flex={1} fontWeight={600}>
					Settings
				</Typography>

				<IconButton onClick={onClose}>
					<CloseIcon />
				</IconButton>
			</Box>

			<Box
				sx={{
					p: 2,
					flex: 1,
					overflowY: 'auto',
				}}
			>
				{children}
			</Box>

			<style>
				{`
                    @keyframes smoothSlideIn {
                        from { transform: translateX(100%); opacity: 0; }
                        to { transform: translateX(0); opacity: 1; }
                    }

                    @keyframes smoothSlideOut {
                        from { transform: translateX(0); opacity: 1; }
                        to { transform: translateX(100%); opacity: 0; }
                    }
                `}
			</style>
		</Drawer>
	);
};

export default SmoothDrawerContainer;
